export class UserCredential {
    account: string;
    password: string;
    name: string;
    description: string;
    position?: string;
    email: string;
    phone: string;
    isActiveDirectory: boolean;
    isAPIUser?: boolean | null;
    isCustomUser?: boolean | null;
    creationDate?: Date | null;
    creationUser?: string;
    modificationDate?: Date | null;
    modificationUser?: string;
    status?: number | null;
    domain: string;
}